import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'lodash';
import positionUtil from './position';
var getViewportSize = positionUtil.getViewportSize,
  getRectMiddle = positionUtil.getRectMiddle,
  isCloseOrEqual = positionUtil.isCloseOrEqual,
  getMaxAllowedBottom = positionUtil.getMaxAllowedBottom,
  getMaxAllowedRight = positionUtil.getMaxAllowedRight;
var CONSTS = {
  INDENT_FROM_EDGE: 12,
  MIN_LIST_HEIGHT: 180,
  SCROLL_KEYS: [37, 38, 39, 40],
  ALIGNMENT: {
    TOP: 'TOP',
    LEFT: 'LEFT',
    BOTTOM: 'BOTTOM',
    RIGHT: 'RIGHT'
  },
  DIRECTION: {
    TOP: 'TOP',
    LEFT: 'LEFT',
    BOTTOM: 'BOTTOM',
    RIGHT: 'RIGHT',
    MIDDLE: 'MIDDLE'
  },
  CHUPCHIK: {
    PADDING: 10,
    POSITION: {
      TOP_LEFT: 'top-left',
      TOP_RIGHT: 'top-right',
      TOP_MIDDLE: 'top-middle',
      BOTTOM_LEFT: 'bottom-left',
      BOTTOM_RIGHT: 'bottom-right',
      BOTTOM_MIDDLE: 'bottom-middle',
      LEFT_TOP: 'left-top',
      LEFT_BOTTOM: 'left-bottom',
      LEFT_MIDDLE: 'left-middle',
      RIGHT_TOP: 'right-top',
      RIGHT_BOTTOM: 'right-bottom',
      RIGHT_MIDDLE: 'right-middle'
    }
  }
};
var getVFit = function getVFit(bottom, top, viewport) {
  return {
    bottom: bottom < getMaxAllowedBottom(viewport),
    top: top > CONSTS.INDENT_FROM_EDGE
  };
};
var getHFit = function getHFit(right, left, viewport) {
  return {
    right: right < getMaxAllowedRight(viewport),
    left: left > CONSTS.INDENT_FROM_EDGE
  };
};
var pickVRange = function pickVRange(preference, fit, top, bottom) {
  if (preference === bottom) {
    return !fit.bottom && fit.top ? top : bottom;
  }
  return !fit.top && fit.bottom ? bottom : top;
};
var pickHRange = function pickHRange(preference, fit, left, right) {
  if (preference === right) {
    return !fit.right && fit.left ? left : right;
  }
  return !fit.left && fit.right ? right : left;
};
var pickRange = function pickRange(_ref) {
  var min = _ref.min,
    max = _ref.max,
    low = _ref.low,
    high = _ref.high,
    alignment = _ref.alignment,
    direction = _ref.direction,
    axis = _ref.axis,
    viewport = _ref.viewport;
  var ALIGNMENT = CONSTS.ALIGNMENT,
    DIRECTION = CONSTS.DIRECTION;
  var getFit = axis === 'X' ? getHFit : getVFit;
  var pick = axis === 'X' ? pickHRange : pickVRange;
  var forward;
  if (direction) {
    forward = axis === 'X' ? DIRECTION.RIGHT : DIRECTION.BOTTOM;
  } else {
    forward = axis === 'X' ? ALIGNMENT.RIGHT : ALIGNMENT.BOTTOM;
  }
  var fit = getFit(max, min, viewport);
  var preference = (direction || alignment) === forward ? high : low;
  return pick(preference, fit, low, high);
};
var getHRange = function getHRange(viewport, buttonRect, optionsRect) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var ALIGNMENT = CONSTS.ALIGNMENT,
    DIRECTION = CONSTS.DIRECTION;
  var alignment = params.alignment || ALIGNMENT.RIGHT;
  var direction = params.direction || DIRECTION.BOTTOM;
  var isHorizontalAlignment = alignment === ALIGNMENT.RIGHT || alignment === ALIGNMENT.LEFT;
  var isMiddleDirection = direction !== DIRECTION.LEFT && direction !== DIRECTION.RIGHT;
  var hOverflow = params.hOverflow || 0;
  buttonRect = _objectSpread(_objectSpread({}, buttonRect), {}, {
    x: buttonRect.x + hOverflow,
    width: buttonRect.width - hOverflow * 2
  });
  var buttonRight = buttonRect.x + buttonRect.width;
  var buttonMiddle = getRectMiddle(buttonRect).x;
  var alignmentLimit = {
    min: buttonRect.x - optionsRect.width,
    max: buttonRight + optionsRect.width
  };
  var directionLimit = {
    min: buttonRight - optionsRect.width + CONSTS.CHUPCHIK.PADDING,
    max: buttonRect.x + optionsRect.width - CONSTS.CHUPCHIK.PADDING
  };
  var hRangeForAlignmentRight = {
    max: alignmentLimit.max,
    min: buttonRight
  };
  var hRangeForAlignmentLeft = {
    max: buttonRect.x,
    min: alignmentLimit.min
  };
  var hRangeForDirectionRight = {
    min: buttonRect.x - CONSTS.CHUPCHIK.PADDING,
    max: directionLimit.max
  };
  var hRangeForDirectionLeft = {
    min: directionLimit.min,
    max: buttonRight + CONSTS.CHUPCHIK.PADDING
  };
  var hRangeForDirectionMiddle = {
    min: buttonMiddle - optionsRect.width / 2,
    max: buttonMiddle + optionsRect.width / 2
  };
  var rangeByAlignment = {
    min: alignmentLimit.min,
    max: alignmentLimit.max,
    low: hRangeForAlignmentLeft,
    high: hRangeForAlignmentRight,
    axis: 'X',
    alignment: alignment,
    viewport: viewport
  };
  var rangeByDirection = {
    min: directionLimit.min,
    max: directionLimit.max,
    low: hRangeForDirectionLeft,
    high: hRangeForDirectionRight,
    axis: 'X',
    direction: direction,
    viewport: viewport
  };
  if (!isHorizontalAlignment && isMiddleDirection) {
    return hRangeForDirectionMiddle;
  }
  return pickRange(isHorizontalAlignment ? rangeByAlignment : rangeByDirection);
};
function getVRange(viewport, buttonRect, optionsRect) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var ALIGNMENT = CONSTS.ALIGNMENT,
    DIRECTION = CONSTS.DIRECTION;
  var alignment = params.alignment || ALIGNMENT.RIGHT;
  var direction = params.direction || DIRECTION.BOTTOM;
  var isHorizontalAlignment = alignment === ALIGNMENT.RIGHT || alignment === ALIGNMENT.LEFT;
  var vOverflow = params.vOverflow || 0;
  buttonRect = _objectSpread(_objectSpread({}, buttonRect), {}, {
    y: buttonRect.y + vOverflow,
    height: buttonRect.height - vOverflow * 2
  });
  var buttonBottom = buttonRect.y + buttonRect.height;
  var directionLimit = {
    min: buttonBottom - optionsRect.height + CONSTS.CHUPCHIK.PADDING,
    max: buttonRect.y + optionsRect.height - CONSTS.CHUPCHIK.PADDING
  };
  var alignmentLimit = {
    min: buttonRect.y - optionsRect.height,
    max: buttonBottom + optionsRect.height
  };
  var vRangeForDirectionBottom = {
    min: buttonRect.y - CONSTS.CHUPCHIK.PADDING,
    max: directionLimit.max
  };
  var vRangeForDirectionTop = {
    min: directionLimit.min,
    max: buttonBottom + CONSTS.CHUPCHIK.PADDING
  };
  var vRangeForAlignmentBottom = {
    min: buttonBottom,
    max: alignmentLimit.max
  };
  var vRangeForAlignmentTop = {
    min: alignmentLimit.min,
    max: buttonRect.y
  };
  var rangeByDirection = {
    min: directionLimit.min,
    max: directionLimit.max,
    low: vRangeForDirectionTop,
    high: vRangeForDirectionBottom,
    axis: 'Y',
    direction: direction,
    viewport: viewport
  };
  var rangeByAlignment = {
    min: alignmentLimit.min,
    max: alignmentLimit.max,
    low: vRangeForAlignmentTop,
    high: vRangeForAlignmentBottom,
    axis: 'Y',
    alignment: alignment,
    viewport: viewport
  };
  return pickRange(isHorizontalAlignment ? rangeByDirection : rangeByAlignment);
}
function getOptionsPosition(viewport, buttonRect, optionsRect) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // eslint-disable-line no-unused-vars
  var hRange = getHRange.apply(void 0, arguments);
  var vRange = getVRange.apply(void 0, arguments);
  var optionsPosition = {
    x: hRange.min,
    width: hRange.max - hRange.min,
    y: vRange.min,
    height: vRange.max - vRange.min
  };
  return _.mapValues(optionsPosition, Math.ceil);
}
var getArrowPosition = function getArrowPosition(buttonRect, optionsPosition) {
  var POSITION = CONSTS.CHUPCHIK.POSITION;
  var buttonMiddle = getRectMiddle(buttonRect);
  var optionsMiddle = getRectMiddle(optionsPosition);
  var alignedRight = isCloseOrEqual(buttonRect.x + buttonRect.width, optionsPosition.x);
  var alignedLeft = isCloseOrEqual(buttonRect.x, optionsPosition.x + optionsPosition.width);
  var alignedTop = !(alignedLeft || alignedRight) && buttonRect.y > optionsPosition.y;
  var directedBottom = isCloseOrEqual(buttonRect.y - CONSTS.CHUPCHIK.PADDING, optionsPosition.y);
  var directedLeft = isCloseOrEqual(buttonRect.x + buttonRect.width, optionsPosition.x + optionsPosition.width - CONSTS.CHUPCHIK.PADDING);
  var directedMiddleHorizontally = isCloseOrEqual(buttonMiddle.y, optionsMiddle.y);
  var directedMiddleVertically = isCloseOrEqual(buttonMiddle.x, optionsMiddle.x);
  if (alignedRight) {
    if (directedMiddleHorizontally) {
      return POSITION.LEFT_MIDDLE;
    }
    return directedBottom ? POSITION.LEFT_TOP : POSITION.LEFT_BOTTOM;
  } else if (alignedLeft) {
    if (directedMiddleHorizontally) {
      return POSITION.RIGHT_MIDDLE;
    }
    return directedBottom ? POSITION.RIGHT_TOP : POSITION.RIGHT_BOTTOM;
  } else if (alignedTop) {
    if (directedMiddleVertically) {
      return POSITION.BOTTOM_MIDDLE;
    }
    return directedLeft ? POSITION.BOTTOM_RIGHT : POSITION.BOTTOM_LEFT;
  }
  if (directedMiddleVertically) {
    return POSITION.TOP_MIDDLE;
  }
  return directedLeft ? POSITION.TOP_RIGHT : POSITION.TOP_LEFT;
};
export default {
  CONSTS: CONSTS,
  getViewportSize: getViewportSize,
  getOptionsPosition: getOptionsPosition,
  getArrowPosition: getArrowPosition
};